import React from 'react';
import { CardHeaderProps } from './types';
import { cn } from '../../../lib/utils';
import { ExternalLink, LucideIcon } from 'lucide-react';

export const CardHeader: React.FC<CardHeaderProps> = ({
  icon,
  title,
  subtitle,
  className,
  gradient,
  iconClassName = "w-6 h-6 text-slate-700",
  link
}) => {

    const renderIcon = () => {
    if (!icon) return null;
    
    if (React.isValidElement(icon)) {
        return icon;
    }
    
    const IconComponent = icon as LucideIcon;
    return <IconComponent className={iconClassName} />;
    };

  return (
    <div className={cn("mb-4", className)}>
      {gradient && (
        <div className={`h-1.5 bg-gradient-to-r ${gradient} -mx-6 -mt-6 mb-6`} />
      )}
      <div className="flex items-start space-x-4">
        {icon && (
          <div className="flex-shrink-0">
            {renderIcon()}
          </div>
        )}
        <div>
          <h3 className="text-lg font-semibold text-slate-900 group-hover:text-sky-600 transition-colors">
            {link ? (
                      <a
                        href={link}
                        target={'_blank'}
                        rel="noopener noreferrer"
                      >
                        {title}
                        <ExternalLink className={cn(
                          "ml-2 w-4 h-4 inline-block align-baseline",
                          "transition-transform duration-300",
                          "group-hover/link:translate-x-1"
                        )} />
                      </a>
                    ) : (
                        title
                    )}

          </h3>
          {subtitle && (
            <p className="text-slate-600 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};